import LoginSimples from '@/components/sessao/LoginSimples'

const handleTokenInvalidoException = function(error, component) {
  LoginSimples.show(component)
}

const A7WebCustomExceptionHandler = {
  handleException: function(error, component) {
    if (error.className && (error.className === 'TokenInvalidoException' ||
      error.className === 'SessaoUsuarioInvalidaException')) {
      handleTokenInvalidoException(error, component)
      return true
    }
    return false
  }
}

export default A7WebCustomExceptionHandler
